import { render, staticRenderFns } from "./SectorMap.vue?vue&type=template&id=9a90dfde&scoped=true"
import script from "./SectorMap.vue?vue&type=script&lang=js"
export * from "./SectorMap.vue?vue&type=script&lang=js"
import style0 from "./SectorMap.vue?vue&type=style&index=0&id=9a90dfde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a90dfde",
  null
  
)

export default component.exports